import React, { ChangeEvent, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Button, Stack } from "@mui/material";
import * as messagesActions from "@/src/store/messages/actions";
import { fileCheck } from "@/src/services/formServiceFunctions";
import FilePreview from "@/src/components/FilePreview/FilePreview";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";

type LoginIndependentFileUploadProps = {
  headline?: string;
  helperText?: string;
  files: File[];
  setFiles: (files: File[]) => void;
  required?: boolean;
};

export default function LoginIndependentFileUpload({ headline, helperText, files, setFiles, required = false }: LoginIndependentFileUploadProps) {
  const [clearInput, setClearInput] = useState(0);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFilesChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileCheckRes = fileCheck(event.target);
    if (fileCheckRes.hasError) {
      messagesActions.addMessage({ type: "error", text: fileCheckRes.errorMsg });
      return;
    }
    if (!event.target.files) {
      return;
    }

    setFiles(Array.from(event.target.files));
  };

  return (
    <Stack spacing={2} key={clearInput}>
      {headline && (
        <Typography align={"center"} component={"h4"} variant={"h6"}>
          {headline}
          {required ? " *" : ""}
        </Typography>
      )}
      {helperText && <FormLegend>{helperText}</FormLegend>}
      <Box sx={{ display: "none" }}>
        <input ref={inputRef} accept="image/*, application/pdf" type="file" onChange={handleFilesChange} />
      </Box>
      <Stack
        direction="row"
        sx={{
          justifyContent: "flex-end",
          marginTop: "1.5rem",
        }}
      >
        {files.length < 1 && (
          <Button component={"span"} onClick={() => inputRef.current?.click()}>
            Datei auswählen
          </Button>
        )}
      </Stack>
      {files.length > 0 && (
        <FilePreview
          name={files[0].name}
          onDelete={() => {
            setFiles([]);
            setClearInput(clearInput + 1);
          }}
        />
      )}
    </Stack>
  );
}
